import type { EntityData } from '@adornis/baseql/entities/types.js';
import { ContractAPI } from '../api/ContractAPI.js';
import type { AppliedContract } from '../entities/AppliedContract.js';

export async function updateContractTaetigkeitsschluessel(
  appliedContract: AppliedContract,
  stableContractObject: EntityData<AppliedContract>,
): Promise<void> {
  const somethingRelatedToTaetigkeitChanged = [
    /**
     * Taetigkeit -> first 5 chars
     */
    appliedContract.agEingruppierung1?.agVertragsInfos?.taetigkeit !==
      stableContractObject.agEingruppierung1?.agVertragsInfos?.taetigkeit,
    appliedContract.agEingruppierung2?.agVertragsInfos?.taetigkeit !==
      stableContractObject.agEingruppierung2?.agVertragsInfos?.taetigkeit,
    /**
     * Max deputat -> worktime -> 9. char
     */
    appliedContract.agEingruppierung1?.agArbeitszeit?.maxDeputat !==
      stableContractObject.agEingruppierung1?.agArbeitszeit?.maxDeputat,
    appliedContract.agEingruppierung2?.agArbeitszeit?.maxDeputat !==
      stableContractObject.agEingruppierung2?.agArbeitszeit?.maxDeputat,
    /**
     * Teilzeit -> worktime -> 9. char
     */
    appliedContract.agEingruppierung1?.agArbeitszeit?.zaehler !==
      stableContractObject.agEingruppierung1?.agArbeitszeit?.zaehler,
    appliedContract.agEingruppierung2?.agArbeitszeit?.zaehler !==
      stableContractObject.agEingruppierung2?.agArbeitszeit?.zaehler,
  ];

  /**
   * nothing changed
   */
  if (!somethingRelatedToTaetigkeitChanged.some(changed => changed)) {
    return;
  }

  const newSchluessel = await ContractAPI.calculateTaetigkeitenschluessel(appliedContract)();

  /**
   * Only update if they are not already changed. Prevents infinite loops when updating the appliedContract
   */
  if (
    appliedContract.agEingruppierung1?.agVertragsInfos &&
    appliedContract.agEingruppierung1.agVertragsInfos.taetigkeitsschluessel !== newSchluessel[0]
  ) {
    appliedContract.agEingruppierung1.agVertragsInfos.taetigkeitsschluessel = newSchluessel[0];
  }
  if (
    appliedContract.agEingruppierung2?.agVertragsInfos &&
    appliedContract.agEingruppierung2.agVertragsInfos.taetigkeitsschluessel !== newSchluessel[1]
  ) {
    appliedContract.agEingruppierung2.agVertragsInfos.taetigkeitsschluessel = newSchluessel[1];
  }
}
